import React, { useState } from "react";
import { useTheme } from "@emotion/react";
import {
  AppBar,
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getOrder, payOrder, updateOrder } from "../../actions/ordrActions";
import { ORDER_UPDATE_RESET } from "../../constants/orderConstants";
import axios from "axios";
import { io } from "socket.io-client";
const socket = io("https://inventoryprojo.herokuapp.com/");

const validationSchema = Yup.object().shape({
  shipped: Yup.boolean().required("Shipped  is required"),
  paid: Yup.boolean().required("Payment status is required"),
});

const EditOrder = () => {
  const dispatch = useDispatch();
  const [ld, setLoading] = useState(false);

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderUpdate = useSelector((state) => state.orderUpdate);
  const { loading, error, success } = orderUpdate;

  const orderGet = useSelector((state) => state.orderGet);
  const {
    loading: loadingGet,
    error: errorGet,
    success: successGet,
    order,
  } = orderGet;
  const [data, setData] = useState(null);

  const params = useParams();

  React.useEffect(() => {
    if (data === "Request cancelled by user") {
      setData(null);
      toast.error(
        "Request cancelled by user.The user must confirm the payment."
      );
    } else if (data === "The initiator information is invalid.") {
      setData(null);
      toast.error(
        "Request cancelled by user.The user must confirm the payment."
      );
    } else if (data === "The service request is processed successfully.") {
      dispatch(payOrder(order._id));
      setData(null);
      toast.success("Payment successful.");
      navigate(`/orders`);
    }
  }, [navigate, data, order, dispatch]);

  console.log(data);
  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }

    if (params.id) {
      dispatch(getOrder(params.id));
    }

    if (success) {
      navigate("/orders");
      toast("Order updated successfully");
      dispatch({ type: ORDER_UPDATE_RESET });
    }
  }, [userInfo, dispatch, navigate, success, params.id]);

  const handleSubmit = ({ paid, shipped }) => {
    dispatch(updateOrder({ _id: params.id, paid, shipped }));
  };

  const handleMpesa = async () => {
    const { _id } = order;
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.get(
      `https://inventoryprojo.herokuapp.com/api/v1/orders/lipa-na-mpesa`,
      config
    );
    console.log(data);
  };
  socket.on("querying", (data) => {
    setLoading(true);
  });

  socket.on("queried", (data) => {
    setLoading(false);
    setData(data);
  });

  return (
    <Container>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {ld && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Edit Order
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {order && (
            <Form
              initialValues={{
                paid: order.paid,
                shipped: order.shipped,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <RadioButtonComponent name={"paid"} />
              <RadioButtonComponent name={"shipped"} />
              <SubmitButton title={"Update order"} />
            </Form>
          )}

          <Button
            variant="contained"
            sx={{
              mt: 10,
            }}
            color="primary"
            onClick={handleMpesa}
          >
            Request Mpesa Payment for this order
          </Button>
        </div>
      </Box>
    </Container>
  );
};

export default EditOrder;
